module.exports = __webpack_public_path__ + "static/media/pb-1.7510e875.png";